import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const pixel_art_filter_faq_data = [
    {
        question: "How Can I Convert a Photo to Pixel Art?",
        answer: "Upload your image, set the modifications to Pixelate the image, customize the settings as you like, and create dazzling pixel art from your image!",
    },
    {
        question: "Who Can Benefit from the Pixel Art Generator?",
        answer: "Pixel art is a great way to add a unique touch to your photos and make them stand out. It's perfect for social media, personal projects, and creative hobbies. Anyone who wants to experiment with different styles and add a personal touch to their photos will love it!",
    },
    {
        question: "What about privacy? Are my photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

const pixel_art_filter_use_cases = [
    {
        title: "Social Media Content",
        description:
            "Platforms such as Instagram and TikTok are getting trendy in pixel art. With our tool, you can use it for creating eye-catching posts, profile pictures, or even animated pixel scenes that will catch your attention in your feed.",
        image: "/images/image-filters/pixel-art-filter-4.webp",
    },
    {
        title: "Personalized Gifts and Merchandise",
        description:
            "Transform your pixel art into custom t-shirts, mugs, posters, or digital prints, all of which will have high quality conversion. So, your art will appear professional in any medium.",
        image: "/images/image-filters/pixel-art-filter-5.webp",
    },
    {
        title: "Turn Your Image into Selling Pixel Ai Art",
        description:
            "Selling pixel art is a great way to bring your creation ideas to market and our tool looks after the production end of things so you can produce your pixel art to sales-ready standard.",
        image: "/images/image-filters/pixel-art-filter-6.webp",
    },
];

const PixelArtFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/pixel-art-filter-1.webp"}
                title={"Enjoy our one-click Pixel Art Generator"}
                description={
                    "It's never been easier to turn your photo into pixel art. Using the AI-powered pixel art filter, you can get professional results in seconds. Just pick up your image, and the smart AI filter does the rest, turning your picture into a vibrant pixel masterpiece. It's a one-click tool which means that you don't need to bother with doing any manual editing and it's perfect for beginners as well as experts. The streamlined workflow saves time and gives you amazing quality, whether you're pixelating portraits, playing with retro designs, or exploring artistic styles. With a click, kickstart your creative ideas."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/pixel-art-filter-2.webp"}
                title={"Get High-Quality Pixel Art Conversion Experience"}
                description={
                    "Convert any photo to pixel art using the advanced AI conversion technology. Whether you want to take in a detailed portrait, a peaceful landscape, or an intricate object, our tool precisely captures that essence. It intelligently maps pixels to get good crisp details and good vivid colors. The pixel art filter does not destroy your original image as with the rest of the methods but it gives your image a unique pixelated appearance. Professional designers, artists, or anyone wanting to produce amazing-looking artwork will love this high-quality transformation."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/pixel-art-filter-3.webp"}
                title={"Create Your Own Unique Pixel Art Avatar"}
                description={
                    "With the pixel art filter, it is easy to design your personalized pixel avatar. This is perfect for adding a retro flavor of your personality to your social media profile, gaming icon, or digital portfolio. Upload your photo and in a few seconds, you will have a pixel avatar that will stand out. Customize your avatar with pixel density, color adjustments, and so on, all with the options you desire. Take part in the trend, and become a pixel persona that's both old and new. Now you do not need years of experience to convert your normal pictures into pixelated art as our tool enables you to achieve that in minutes."
                }
            />
            <UseCases
                data={pixel_art_filter_use_cases}
                title={"Creative and Pretty Pixel Art Filters for Everyone"}
            />
            <SellFaq data={pixel_art_filter_faq_data} />
        </PBox>
    );
};

export default PixelArtFilter;
